/**
 * Where to send a browser that loaded the app from its raw hosting hostname
 * (employ-engage-super-admin-portal.fly.dev) instead of its real domain.
 *
 * Those hostnames serve the same build, but the API only allows the
 * configured origins, so every request is blocked by CORS — which surfaces as
 * a missing front-token header and looks like a proxy fault. Redirecting is
 * kinder than letting someone sign in against a wall.
 *
 * Deliberately narrow: only raw fly.dev hostnames are redirected, so custom
 * domains, localhost and preview hosts are left alone.
 *
 * @returns the URL to send the browser to, or null to stay put.
 */
export const canonicalRedirectUrl = (currentUrl, canonicalUrl) => {
    if (!canonicalUrl)
        return null;
    let current;
    let canonical;
    try {
        current = new URL(currentUrl);
        canonical = new URL(canonicalUrl);
    }
    catch {
        return null;
    }
    if (!current.hostname.endsWith('.fly.dev'))
        return null;
    if (current.host === canonical.host)
        return null;
    return `${canonical.origin}${current.pathname}${current.search}${current.hash}`;
};
